<template>
    <span class="text-primary mr-2" v-if="$temAcessoView('CTRLACS-APP-02')"
        ><i
            class="fa fa-info-circle fa-lg icon-button"
            title="Detalhar"
            @click.stop="detalhar()"
        ></i
    ></span>
</template>

<script>
export default {
    props: {
        aplicacao: {
            type: Object
        }
    },

    methods: {
        detalhar() {
            this.$router.push({
                name: 'Aplicacoes_Detalhar',
                params: { aplicacaoId: this.aplicacao.aplicacaoId }
            })
        }
    }
}
</script>
